package com.essntl.features.service.data.supabase.service

import com.essntl.features.service.domain.model.service.ServiceModel
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonNull
import kotlinx.serialization.json.JsonPrimitive

internal fun ServiceModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    if (title.isNotEmpty()) {
        requestMap["title"] = JsonPrimitive(title)
    }

    if (!category.isNullOrEmpty()) {
        requestMap["category"] = JsonPrimitive(category!!)
    }

    if (areaId != null) {
        requestMap["area_id"] = JsonPrimitive(areaId)
    }

    description?.let { d ->
        requestMap["description"] = JsonPrimitive(d)
    }

    if (!headline.isNullOrEmpty()) {
        requestMap["headline"] = JsonPrimitive(headline!!)
    }

    if (primaryImage != null) {
        requestMap["primary_image"] = JsonPrimitive(if (primaryImage!!.isEmpty) null else primaryImage!!.id)
    }

    if (tags != null) {
        requestMap["tags"] = JsonArray(tags!!.map { JsonPrimitive(it) })
    }

    if (images != null) {
        requestMap["images"] = JsonArray(images!!.map { JsonPrimitive(it) })
    }

    if (!referenceCode.isNullOrEmpty()) {
        requestMap["reference_code"] = JsonPrimitive(referenceCode)
    }

    if (!internalNotes.isNullOrEmpty()) {
        requestMap["internal_notes"] = JsonPrimitive(internalNotes)
    }

    if (qbItemId != null) {
        requestMap["qb_item_id"] = JsonPrimitive(qbItemId)
    }

    if (hasDynamicPrice != null) {
        requestMap["has_dynamic_price"] = JsonPrimitive(hasDynamicPrice ?: false)
    }

    return requestMap
}